import { render, staticRenderFns } from "./taskField.vue?vue&type=template&id=e0855d7c&scoped=true&"
import script from "./taskField.vue?vue&type=script&lang=js&"
export * from "./taskField.vue?vue&type=script&lang=js&"
import style0 from "./taskField.vue?vue&type=style&index=0&id=e0855d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0855d7c",
  null
  
)

export default component.exports